/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/fight_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M21.646 18.646a.5.5 0 01.707.707L21.207 20.5l2.146 2.146-.707.707-2.146-2.146-1.146 1.146a.5.5 0 11-.708-.706l1.146-1.146L16 16.707 12.207 20.5l1.146 1.146a.5.5 0 01-.707.708L11.5 21.207l-2.146 2.146-.707-.707 2.146-2.146-1.146-1.146a.5.5 0 01.707-.707l1.146 1.146L15.293 16 8.646 9.354l.707-.707L16 15.293l6.646-6.646.707.707L16.707 16l3.793 3.793 1.146-1.147z"/>'
  }
})
